module.exports = __webpack_public_path__ + "static/media/reacao.c74880ee.svg";